// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum TargetTypes {
	Unknown = 0,
	SemiTrailerTruck = 1,
	PassengerTruck = 2,
	Car = 4,
	Motorcycle = 8,
	Bike = 16,
	Pedestrian = 32,
	Camper = 64,
	Bus = 128,
	Trailer = 256,
	Boat = 512,
	UtilityVehicle = 1024,
	Bobtail = 2048,
	Wheel = 4096,
	Unspecified = 8192,
	LightRailVehicle = 16384,
	Train = 32768,
	Van = 65536,
	GolfCartLsv = 131072,
	PassengerTruckDually = 262144,
}

export const TargetTypesDisplayNames: { [key in keyof typeof TargetTypes]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"SemiTrailerTruck": "Semi Truck",
	1 : "Semi Truck",
	"PassengerTruck": "Passenger Truck",
	2 : "Passenger Truck",
	"Car": "Car",
	4 : "Car",
	"Motorcycle": "Motorcycle",
	8 : "Motorcycle",
	"Bike": "Bike",
	16 : "Bike",
	"Pedestrian": "Pedestrian",
	32 : "Pedestrian",
	"Camper": "Camper",
	64 : "Camper",
	"Bus": "Bus",
	128 : "Bus",
	"Trailer": "Trailer",
	256 : "Trailer",
	"Boat": "Boat",
	512 : "Boat",
	"UtilityVehicle": "Utility Vehicle",
	1024 : "Utility Vehicle",
	"Bobtail": "Bobtail",
	2048 : "Bobtail",
	"Wheel": "Wheel",
	4096 : "Wheel",
	"Unspecified": "Unspecified",
	8192 : "Unspecified",
	"LightRailVehicle": "Light Rail Vehicle",
	16384 : "Light Rail Vehicle",
	"Train": "Train",
	32768 : "Train",
	"Van": "Van",
	65536 : "Van",
	"GolfCartLsv": "Golf Cart or LSV",
	131072 : "Golf Cart or LSV",
	"PassengerTruckDually": "PassengerTruckDually",
	262144 : "PassengerTruckDually",
}

export const getTargetTypesDisplayName = (key: TargetTypes | number |  (keyof typeof TargetTypes & string)) => {
	if (isNaN(+key)) return TargetTypesDisplayNames[key];
	return Object.keys(TargetTypesDisplayNames).filter(v => parseInt(v) >= 0 && (parseInt(v) & Number(key)) > 0).map(v => TargetTypesDisplayNames[v as (keyof typeof TargetTypes)]).join(', ');
}

